// extracted by mini-css-extract-plugin
module.exports = {"dashCard":"PrepaidCard_dashCard__1y_tH"};